export const DATA_BROWSER_CONFIG = {
    survey: 'PACCOMOPPORTUNITY2020',
    dataset: 'SE',
    groups: [
        {
            name: 'Population',
            icon: 'population.svg',
            variables: [
                { table: 'A10064', name: 'A10064_017', label: 'Population Density' },
                { table: 'A10064', name: 'A10064_005', label: 'Current Population' },
                { table: 'A10064', name: 'A10064_006', label: 'Incoming Population - Census' },
                {
                    table: 'A10064',
                    name: 'A10064_096',
                    label: 'Incoming Population - Housing Development',
                },
                { table: 'A10064', name: 'A10064_007', label: 'Projected Population - Census' },
                {
                    table: 'A10064',
                    name: 'A10064_097',
                    label: 'Projected Population - Housing Development',
                },
                {
                    table: 'A10064',
                    name: 'A10064_018',
                    label: 'Population Growth - Census (Percentage)',
                },
                {
                    table: 'A10064',
                    name: 'A10064_019',
                    label: 'Population Growth - Housing Development (Percentage)',
                },
            ],
        },
        {
            name: 'Households',
            icon: 'households.svg',
            variables: [
                { table: 'A10064', name: 'A10064_022', label: 'Current Median Household Income' },
                { table: 'A10064', name: 'A10064_023', label: 'Projected Median Household Income' },
                { table: 'A10064', name: 'A10064_026', label: 'Current Average Household Income' },
                { table: 'A10064', name: 'A10064_027', label: 'Current Number of Households' },
                {
                    table: 'A10064',
                    name: 'A10064_020',
                    label: 'Households, Owner Occupied (Percentage)',
                },
                {
                    table: 'A10064',
                    name: 'A10064_021',
                    label: 'Households, Renter Occupied (Percentage)',
                },
                {
                    table: 'A10064',
                    name: 'A10064_101',
                    label: 'Median House Value for All Owner-Occupied Housing Units',
                },
                {
                    table: 'A10064',
                    name: 'A10064_102',
                    label: 'Employment Status for Total Population 16 Years and Over',
                },
            ],
        },
        {
            name: 'Facilities',
            icon: 'facilities.svg',
            variables: [
                { table: 'A10064', name: 'A10064_002', label: 'Current Number of Facilities' },
                {
                    table: 'A10064',
                    name: 'A10064_028',
                    label: 'Current Number of Climate Controlled Facilities',
                },
                {
                    table: 'A10064',
                    name: 'A10064_025',
                    label: 'Current Number of Facilities Offering Climate Control (Percentage)',
                },
                { table: 'A10064', name: 'A10064_003', label: 'Number of Incoming Facilities' },
                { table: 'A10064', name: 'A10064_004', label: 'Projected Number of Facilities' },
                { table: 'A10064', name: 'A10064_008', label: 'Current Gross Square Footage' },
                { table: 'A10064', name: 'A10064_009', label: 'Incoming Gross Square Footage' },
                { table: 'A10064', name: 'A10064_010', label: 'Projected Gross Square Footage' },
                { table: 'A10064', name: 'A10064_011', label: 'Current Rentable Square Footage' },
                { table: 'A10064', name: 'A10064_012', label: 'Incoming Rentable Square Footage' },
                { table: 'A10064', name: 'A10064_013', label: 'Projected Rentable Square Footage' },
                { table: 'A10064', name: 'A10064_030', label: '%Gross Drive-Up Square Footage' },
                { table: 'A10064', name: 'A10064_024', label: '%Rentable Drive-Up Square Footage' },
            ],
        },
        {
            name: 'Saturation',
            icon: 'saturation.svg',
            variables: [
                { table: 'A10064', name: 'A10064_014', label: 'Current Square Footage per Capita' },
                {
                    table: 'A10064',
                    name: 'A10064_029',
                    label: 'Current Square Footage per Household',
                },
                {
                    table: 'A10064',
                    name: 'A10064_015',
                    label: 'Projected Square Footage per Capita - Census',
                },
                {
                    table: 'A10064',
                    name: 'A10064_0915',
                    label: 'Projected Square Footage per Capita - Housing Development',
                },
            ],
        },
        {
            name: 'Crime',
            icon: 'crime.svg',
            variables: [{ table: 'A10064', name: 'A10064_100', label: 'EASI Total Crime Index' }],
        },
    ],
};

export default DATA_BROWSER_CONFIG;
